import InitializeLayout from '@js/layout';

import ProductManager from '@js/managers/productManager';

InitializeLayout();

ProductManager.initialize();
